// extracted by mini-css-extract-plugin
export var duration = "plans-module--duration--94afa";
export var features = "plans-module--features--75960";
export var inner = "plans-module--inner--8de74";
export var item = "plans-module--item--a51fa";
export var items = "plans-module--items--a5911";
export var link = "plans-module--link--6d02e";
export var price = "plans-module--price--d74ad";
export var root = "plans-module--root--19c1e";
export var title = "plans-module--title--b4f61";